import { mapMutations, mapState } from 'vuex';

export default {
    computed: {
        ...mapState('common', ['dialogs', 'panels']),
        elDialogs() {
            return new Proxy(this.dialogs, {
                set: (target, prop, value) => {
                    this.TOGGLE_DIALOG({ [prop]: value });

                    return true;
                },
            });
        },
        elPanels() {
            return new Proxy(this.panels, {
                set: (target, prop, value) => {
                    this.TOGGLE_PANEL({ [prop]: value });

                    return true;
                }
            });
        }
    },
    methods: {
        ...mapMutations('common', ['TOGGLE_DIALOG', 'TOGGLE_PANEL']),
    }
}
